<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text">
            <CCol md="6" lg="6" xl="6"> Registrar producciones </CCol>
            <CCol md="6" lg="6" xl="6">
              <router-link :to="{ name: 'Produccion', params: { config: config } }" class="float-right">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />
                  Regresar
                </CButton>
              </router-link>

              <CButton style="margin-bottom: 10px; height: 35px;" @click="onClearItems = true" color="primary" class="float-right mr-1 btn-header">
                Limpiar tabla
              </CButton>
            </CCol>
          </CCardHeader>
          <CCardBody style="margin-top: 0px; padding-top: 10px;">
            <CDataTable hover bordered small fixed :loading="onSendingItems" :items="getComputedRows" :fields="fields" :items-per-page="Number(50)" :noItemsView="noItems">

              <template #COPIAR="{ item }">
                <th style="padding: 10px 5px 5px 5px;" :class="`state-${item.state}`">
                  <div class="popUp" v-show="item.showErrorMessage">
                    <span>{{ item.errorMessage }}</span>
                  </div>
                  <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px;" color="ghost-light" @click="copyAll(item.index)" square size="sm">
                    <!-- <CIcon style="width:10px; margin: 0px;" name="cil-copy" /> -->
                    <img style="width:15px; height: 15px;" src="../../assets/icons/copy.png" class="imagen" >
                  </CButton>
                  <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px; margin-top:15px;" color="warning" v-show="item.state == 'ERROR'" @click="item.showErrorMessage = !item.showErrorMessage" square size="sm">
                    <CIcon style="width:10px; margin: 0px;" name="cil-warning" />
                  </CButton>
                </th>
              </template>

              <template #FECHA="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div class="d-flex align-items-center">
                    <CInput :value.sync="items[index].fecha" type="date" class="w-100" />
                    <CButton v-c-tooltip="{content: 'Copiar la fecha en las filas vacías hasta donde haya una fila con información', placement: 'right'}" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'fecha')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>

              <template #CULTIVO="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div class="d-flex align-items-center">
                    <v-select v-model="items[index].cultivo" :options="cultivos" :loading="isLoadingPage" placeholder="Selecciona un cultivo">
                      <template #open-indicator="{ attributes }">
                        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </v-select>
                    <CButton v-c-tooltip="{ content: 'Copiar la cultivo en las filas vacías hasta donde haya una fila con información', placement: 'right'}" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'cultivo')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen">
                    </CButton>
                  </div>
                </td>
              </template>

              <template #EMBALAJE="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div class="d-flex align-items-center">
                    <v-select v-model="items[index].embalaje" :options="getEmbalaje(item.cultivo)" :loading="isLoadingPage" class="margin-multi" placeholder="Selecciona un embalaje">
                      <template #open-indicator="{ attributes }">
                        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </v-select>
                    <CButton v-c-tooltip="{ content: 'Copiar el embalaje en las filas vacías hasta donde haya una fila con información', placement: 'right'}" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'embalaje')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen">
                    </CButton>
                  </div>
                </td>
              </template>

              <template #CANTIDAD="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div class="d-flex align-items-center">
                    <CInput :value.sync="items[index].cantidad_eq" placeholder="Cantidad" type="number" invalidFeedback="Campo requerido" />
                    <CButton v-c-tooltip="{ content: 'Copiar el cantidad en las filas vacías hasta donde haya una fila con información', placement: 'right'}" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'cantidad_eq')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen">
                    </CButton>
                  </div>
                </td>
              </template>

              <template #PESO="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div v-if="item.embalaje && item.embalaje.type == 'piezas'" class="d-flex align-items-center">
                    <CInput :value.sync="items[index].peso" placeholder="Peso kg." type="number" invalidFeedback="Campo requerido" />
                    <CButton v-c-tooltip="{
                        content: 'Copiar la peso en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'peso')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>

              <template #UBICACION="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div class="d-flex align-items-center">
                    <multiselect style="width: 180px; height: 1px;" v-model="items[index].ubicaciones" :options="ubicaciones" :multiple="true" selectLabel="" deselectLabel="" label="label" :loading="isLoadingPage" selectedLabel="" track-by="label" placeholder="Selecciona una o varias ubicaciones" :close-on-select="false" :clear-on-select="false" title="Selecciona una o varias ubicaciones">
                      <template #no-options>Sin resultados.</template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length > 1 && !isOpen">{{ values.length }} ubicaciones</span></template>
                    </multiselect>
                    <CButton v-c-tooltip="{
                        content: 'Copiar las ubicaciones en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'ubicaciones')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>

              <template #COMENTARIO="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div class="d-flex align-items-center">
                    <CInput :value.sync="items[index].comentarios" placeholder="Comentarios..." type="text" />
                    <CButton v-c-tooltip="{
                        content: 'Copiar el comentario en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'comentarios')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>

              <template #BORRAR="{ item, index }">
                <td :class="`state-${item.state}`">
                  <div>
                    <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px;" @click="borrarFila(index)" color="ghost-light" square size="sm">
                      <img style="width:15px; height: 15px;" src="../../assets/icons/trash.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
            </CDataTable>
          </CCardBody>

          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Produccion', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>
            <CButton @click="saveItems()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal size="sm" title="Cambiando ubicacion raiz" :centered="true" color="warning" :show.sync="onChangeRootLocation" @click="doChangeRootLocation" @close="dontChangeLocation" :no-close-on-backdrop="true">
        <CRow>
          <CCol>
            Al cambiar la ubicación raiz durante la captura, la información del formulario será borrada, desea continuar?
          </CCol>
        </CRow>
        <template #footer>
          <CButton @click="doChangeRootLocation" color="success">Aceptar</CButton>
          <CButton @click="dontChangeLocation" color="danger">Cancelar</CButton>
        </template>
      </CModal>

      <CModal size="sm" title="Producción" :centered="true" :closeOnBackdrop="false" color="info" :show.sync="onSendingItems" class="text-center">
        <span v-if="onSendedItems">La información se ha procesado</span>
        <span v-else>¡Un momento, la información se está guardando!.</span>
        <template #footer>
          <CButton v-if="onSendedItems" @click="onSendingItems = false" class="px-4 mx-3 btn-lg" color="info">
            <span>Aceptar</span>
          </CButton>
          <CButton v-else class="px-4 mx-3 btn-lg" color="info">
            <div>
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow height-custom flex align-items-center">
                  <div class="sk-flow-dot bg-load-white"></div>
                  <div class="sk-flow-dot bg-load-white"></div>
                  <div class="sk-flow-dot bg-load-white"></div>
                </div>
              </div>
            </div>
          </CButton>
        </template>
      </CModal>

      <CModal size="sm" title="Producción" :centered="true" color="warning" :show.sync="onClearItems">
        Se limpiara la información de la tabla.
        <template #footer>
          <CButton @click="onClearItems = false"  color="secondary">Cancelar</CButton>
          <CButton @click="clearItems()"  color="warning">Aceptar</CButton>
        </template>
      </CModal>

      <CModal size="sm" title="Producción" :centered="true" color="info" :show.sync="onCopyItems">
        Ya no hay espacios disponibles para poder copiar.
        <template #footer>
          <CButton @click="onCopyItems = false"  color="info">Aceptar</CButton>
        </template>
      </CModal>

    </CRow>
  </div>
</template>

<script>

import MultiSelectC from "../../customComponents/MultiSelectC";
import Multiselect from "vue-multiselect";
import moment from "moment";
import Treeselect from '@riophae/vue-treeselect'
import TableCollapse from "../../customComponents/TableCollapse1";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const STATE_NORMAL = 'NORMAL'
const STATE_PENDING = 'PENDING'
const STATE_SUCCESS = 'SUCCESS'
const STATE_ERROR = 'ERROR'

const fields = [
  { key: "COPIAR", label: "", _style: "width:1%" },
  { key: "FECHA", label: "Fecha", _style: "width:15%" },
  { key: "CULTIVO", label: "Cultivo", _style: "width:15%" },
  { key: "EMBALAJE", label: "Embalaje", _style: "width:15%" },
  { key: "CANTIDAD", label: "Cantidad", _style: "width:7%" },
  { key: "PESO", label: "Peso (piezas)", _style: "width:7%" },
  { key: "UBICACION", label: "Ubicación", _style: "width:15%" },
  { key: "COMENTARIO", label: "Comentario", _style: "width:15%" },
  { key: "BORRAR", label: "", _style: "width:1%" },
]

const baseFields = {
  fecha: "",
  cultivo: null,
  embalaje: null,
  cantidad_eq: 0,
  peso: 0,
  ubicaciones: [],
  comentarios: "",
  //
  fechahora: "",
  cultivo_id: null,
  ubicacion_raiz_id: null,
}

const requiredFields = [
  "fecha",
  "cultivo",
  "embalaje",
  "cantidad_eq",
  "peso",
  "ubicaciones",
]

const stateFields = {
  //
  state: STATE_NORMAL,
  errorMessage: "",
  showErrorMessage: false,
}

export default {
  name: "NuevoProducciones",
  components: {
    Multiselect,
    MultiSelectC,
    TableCollapse,
    Treeselect,
    vSelect,
  },
  data() {
    return {
      noItems: {
        noResults: "Sin Resultados",
        noItems: "Sin Resultados"
      },
      fields,
      config: this.$route.params.config,
      items: [],
      tempItems: [],

      cultivos: [],
      cultivosAll: [],
      ubicaciones: [],
      ubicacionesAll: [],

      isLoadingPage: false,
      ubicacionRaizOld: {},
      onChangeRootLocation: false,
      onSendedItems: false,
      onSendingItems: false,
      onClearItems: false,
      onCopyItems: false,
    }
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    getComputedRows() {
      const some = this.items.map((item, index) => {
        return {
          ...item,
          state: this.getState(item),
        }
      })
      return this.items.map((item, index) => {
        return {
          ...item,
          state: this.getState(item),
        }
      })
    }
  },
  watch: {
    items: {
      handler(newValue, oldValue) {
        this.verifyModifiedItems(newValue)
      },
      deep: true
    },
    ubicacionRaiz(newValue, oldValue) {
      if(this.items.some(({actividades,fecha,trabajador,ubicaciones,costop,costoc,showpop,})=>actividades||fecha||trabajador||ubicaciones.length>0||costop||costoc||showpop)){
        if(newValue.value!==this.ubicacionRaizOld.value){
          this.onChangeRootLocation = true
          this.ubicacionRaizOld = oldValue
        }
      }else{
        this.actualizarInfo()
      }
    }
  },
  created() {
    this.$store.dispatch('getNanoid')
    this.isLoadingPage = true
    document.addEventListener("wheel", function() {
      if(document.activeElement.type === "number") {
        document.activeElement.blur()
      }
    })
    this.fillItems()
    this.actualizarInfo()
  },
  methods: {
    fillItems() {
      const items = []
      for (let index = 0; index < 11; index++) {
        items.push({
          index,
          ...baseFields,
          ...stateFields,
        })
      }
      this.items = items
    },
    getState(item) {
      const isFilled = requiredFields.every(key => {
        if (Array.isArray(item[key])) {
          return item[key] && item[key].length > 0
        }
        return item[key] !== "" && item[key] !== null && item[key] !== undefined
      })
      if (isFilled && item.state == STATE_NORMAL) {
        return STATE_PENDING
      }
      return item.state
    },
    doChangeRootLocation() {
      this.fillItems()
      this.actualizarInfo()
      this.onChangeRootLocation = false
    },
    dontChangeLocation() {
      this.$store.dispatch("setRootLocation", this.ubicacionRaizOld)
      this.onChangeRootLocation = false
    },
    copyAll(pos) {
      this.items.forEach((item, index) => {
        requiredFields.forEach(field => {
          if (index > pos && (Array.isArray(item[field]) && item[field].length === 0)) {
            item[field] = [...this.items[pos][field]]
          }
          if (index > pos && (item[field] == "" || item[field] == null)) {
            item[field] = this.items[pos][field]
          }
        })
      })
      this.onCopyItems = true
    },
    clonarCelda(item, fila) {
      let info = this.items[item][fila]
      for (let index = item+1; index < this.items.length; index++) {
        if (this.items[index][fila] == "" || this.items[index][fila] == null) {
          this.items[index][fila] = info
        }else{
          break;
        }
      }
    },
    borrarFila(item) {
      const copyItems = [...this.items]
      copyItems[item] = {
        index: item,
        ...baseFields,
        ...stateFields,
      }
      this.items = copyItems
    },
    actualizarInfo() {
      this.isLoadingPage = true

      const ubicacionesTemplate = this.ubicacionRaizValue ? {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      } : {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ],
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }

      const requests = [
        this.$store.dispatch("customHTTP", ubicacionesTemplate),
        this.$store.dispatch("customHTTP", { schema: "cultivos" })
      ]

      Promise.all(requests).then(([ubicaciones, cultivos]) => {

        this.cultivos = cultivos.data.map(cultivo => {
          const variedad = cultivo.payload.variedad || ''
          return { value: cultivo.id, label: `${cultivo.payload.nombre} ${variedad}`}
        })
        this.cultivosAll = cultivos.data

        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre }
        })
        this.ubicacionesAll = ubicaciones.data

        this.isLoadingPage = false

      }).catch(error => {
        console.error("Error al cargar las ubicaciones:", error)
        this.isLoadingPage = false
      })
    },
    getEmbalaje(cultivo) {
      if (cultivo) {
        const cultivoSelect = this.cultivosAll?.find(cult => cult.id == cultivo.value)
        if (cultivoSelect) {
          return cultivoSelect.payload.embalajes.map(embalaje => {
            return {
              value: embalaje.nombre,
              label: embalaje.nombre,
              eq: Number(embalaje.equivalencia),
              type: embalaje.tipo ?? 'kilos'
            }
          })
        }
      }
      return []
    },
    async saveItems() {

      // Filtra las items que están pendientes o con error
      const allowed = [STATE_PENDING, STATE_ERROR]
      const documents = this.getComputedRows.filter(item => allowed.includes(item.state)).map((item, index) => {
        return {
          index: item.index,
          schema: "producciones",
          payload: {
            encabezado: {
              "fechahora": moment(item.fecha).format("YYYY-MM-DD HH:mm:ss"),
              "cultivo_id": item.cultivo ? item.cultivo.value : null,
              "embalaje": item.embalaje ? item.embalaje.value : null,
              "cantidad": Number(item.cantidad_eq),
              "peso": Number(item.peso),
              "ubicaciones": item.ubicaciones && item.ubicaciones.length > 0 ? item.ubicaciones.map(ubicacion => ubicacion.value) : [],
              "comentarios": item.comentarios,
              "ubicacion_raiz_id": this.ubicacionRaiz ? this.ubicacionRaiz.value : null,
            }
          }
        }
      })

      if (!documents || !documents.length) return

      this.onSendingItems = true
      this.onSendedItems = false

      for (const item of documents) {
        try {
          await this.$store.dispatch("customDocumentoAddHTTP", item)

          const itemFinded = this.items.find(it => it.index === item.index)
          if (itemFinded) {
            itemFinded.state = STATE_SUCCESS
            itemFinded.errorMessage = ""
          }
        } catch (error) {
          const itemFinded = this.items.find(it => it.index === item.index)
          if (itemFinded) {
            itemFinded.state = STATE_ERROR
            itemFinded.errorMessage = error?.message || "Error al enviar el documento"
          }
        }
      }

      this.onSendedItems = true
      this.onSendingItems = false

    },
    clearItems() {
      this.onClearItems = false
      this.fillItems()
    },
    verifyModifiedItems(newItems) {
      newItems.forEach((item, index) => {
        // Si alguno de los campos requeridos cambio comprando con tempItems, seteamos estado normal
        if (this.tempItems[index]) {
          const isModified = Object.keys(baseFields).some(field => {
            // si es un array, comparamos su contenido
            if (Array.isArray(item[field])) {
              return JSON.stringify(item[field]) !== JSON.stringify(this.tempItems[index][field])
            }
            // si es un object, comparamos sus propiedades
            if (typeof item[field] === 'object' && item[field] !== null) {
              return JSON.stringify(item[field]) !== JSON.stringify(this.tempItems[index][field])
            }
            // si es un string o number, comparamos directamente
            return item[field] !== this.tempItems[index][field]
          })
          // Si el item estaba en estado SUCCESS y se modificó, lo cambiamos a NORMAL
          if (isModified && this.tempItems[index].state === STATE_SUCCESS) {
            item.state = STATE_NORMAL
          }
        }
      })
      this.tempItems = JSON.parse(JSON.stringify(newItems))
    }
  }
}
</script>

<style src="../../assets/scss/multiselect.css"></style>
<style src="../../assets/scss/vue-select.css"></style>
<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style src="../../assets/scss/tree-select.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fechaInput{
  width: 90%;
  padding: 2px;
}
.selectFit{
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  padding-left: 0%;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    /* top: 3px; */
    /* right: 12px; */
    right: 10%;
    z-index: 1;
    color: black;
    opacity: 1;
}
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}
[data-popper-placement='bottom-start'] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15)
}
td{
  position:relative; padding: 10px 5px 5px 5px;
}
.popUp{
  position:absolute;
  display: block;
  width: 300px;
  z-index: 2;
  background-color: rgb(255, 0, 0);
  border-radius: 10px;
  color: white;
  padding: 10px;
  margin-left: 35%;
  margin-top: 20px;
}
.buttonClon{
  width:15px;
  height:15px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 10px;
  /* position:absolute;  */
  /* bottom: 20%;  */
  top: 30px;
  left: 90%;
  /* display: block !important; */
}
.btnUbi2{
  /* border-left: 0ch; */
  border:0ch;
  top: 8px;
  z-index: 2;
}
.buttonUbi{
  width:17px;
  height:17px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 0%;
  /* display: block !important; */
}
.buttonClonarUbi{
  width:15px;
  height:15px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 5px;
  /* left: 85%; */
  /* display: block !important; */
}
.divUbi{
  width: 40px;
  position:absolute;
  bottom:0;
  /* left:90%;
  bottom: 20%;  */
  z-index: 2;
  /* right: 10px; */
  display: inline !important;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] { -moz-appearance:textfield; }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}

.state-PENDING {
  background-color: #ecf4ff;
  color: #004085;
}
.state-SUCCESS {
  background-color: #d4edda;
  color: #155724;
}
.state-ERROR {
  background-color: #f8d7da;
  color: #721c24;
}

</style>
